export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-1-8772b2946b7a841384dfb4db7cf9ac7b.jpg";